<template lang="html">
  <v-footer
    inset
    height="36"
    app
    class="pa-0"
    v-if="skinProp('footerLogo')"
  >
    <v-layout
      fill-height
    >
      <v-flex
        fill-height
        shrink="1000"
      >
        <img :src="skinProp('footerLogo')" />
      </v-flex>
      <v-flex
        fill-height
        grow="1000"
        class="pl-1"
      >
        <div
          class="powered-by"
          :style="{backgroundColor: skinProp('colors.primary')}"
        >
          Powered By Highlight
        </div>
      </v-flex>
    </v-layout>
  </v-footer>
</template>

<style lang="scss" scoped>
img {
  max-height: 100%;
}
.powered-by {
  color: #fff;
  text-align: center;
  height: 100%;
  width: 100%;
  font-style: italic;
  font-weight: bold;
  align-items: center;
  justify-content: center;
  display: flex;
}
</style>

<script>
export default {

}
</script>
